export default "__VITE_ASSET__93BFdvGD__"